/* istanbul ignore file */
/* eslint-disable max-lines */
/* eslint-disable sonarjs/no-duplicate-string */
import {StyleType, CssColor, wixColor} from '@wix/editor-platform-ooi-metadata-resolver';
import {createStylesParam, createStylesParams, StyleParamType, wixColorParam, wixFontParam} from '@wix/tpa-settings';
import {AddToCartActionOption} from '@wix/wixstores-client-core';
import {ImageModeValues} from '@wix/wixstores-client-core/dist/es/src/media/constants';
import type {
  FilterOnlyBooleanStyleParamsKeys,
  IGenericStylesParams,
  IGenericStylesParamsValues,
} from '@wix/wixstores-client-storefront-common';
import {
  DynamicPaymentMethodsShape,
  DynamicPaymentMethodsTheme,
} from '@wix/wixstores-client-storefront-sdk/dist/es/src/enums/productPageSettings.enums';
import {GalleryLayoutID} from '../../productPage/components/Layouts/ResponsiveLayout/ResponsiveLayout.cssVars';
import {
  Alignment,
  ButtonOptionWidth,
  GalleryNavigationLocation,
  GalleryNavigationPosition,
  GalleryNavigationType,
  ImageRatio,
  InfoSectionLayoutId,
  LayoutId,
  PaymentOptionsBreakdownTheme,
  ProductBorderStyleType,
  SocialShareIconsTheme,
  StickyColumnType,
  SubscriptionPlansOneTimePurchaseOptionLocation,
  TextualOptionType,
} from '../../productPage/constants';

export {customCssVars} from './customCssVars/customCssVars';

export type IStylesParams = IGenericStylesParams<StylesParamKeys>;

export type IStylesParamsValues = IGenericStylesParamsValues<StylesParamKeys>;

export type BooleanStyleParamsKeys = FilterOnlyBooleanStyleParamsKeys<StylesParamKeys>;

export type StylesParamKeys = {
  full_width: StyleParamType.Boolean;
  productPage_buyNowButtonEnabled: StyleParamType.Boolean;
  productPage_galleryZoom: StyleParamType.Boolean;
  productPage_infoSectionShowDeviders: StyleParamType.Boolean;
  productPage_navigation: StyleParamType.Boolean;
  productPage_breadcrumbsColor: StyleParamType.Color;
  productPage_breadcrumbsFont: StyleParamType.Font;
  productPage_openMinicart: StyleParamType.Boolean;
  productPage_paymentOptionsBreakdown: StyleParamType.Boolean;
  productPage_productAction: StyleParamType.Boolean;
  productPage_productInfoSection: StyleParamType.Boolean;
  productPage_stickyContainerEnabled: StyleParamType.Boolean;
  productPage_stockIndicator: StyleParamType.Boolean;
  productPage_productPrice: StyleParamType.Boolean;
  productPage_showDiscountName: StyleParamType.Boolean;
  productPage_productQuantity: StyleParamType.Boolean;
  productPage_productSku: StyleParamType.Boolean;
  productPage_socialNetworkwhatsapp: StyleParamType.Boolean;
  productPage_socialNetworkfacebook: StyleParamType.Boolean;
  productPage_socialNetworkpinterest: StyleParamType.Boolean;
  productPage_socialNetworks: StyleParamType.Boolean;
  productPage_socialNetworktwitter: StyleParamType.Boolean;
  productPage_wishlistEnabled: StyleParamType.Boolean;
  productPage_dynamicPaymentMethodsEnabled: StyleParamType.Boolean;
  responsive: StyleParamType.Boolean;
  productPage_flipColumns: StyleParamType.Boolean;
  productPage_stickyColumnEnabled: StyleParamType.Boolean;
  productPage_stickyColumnType: StyleParamType.Number;
  productPage_stickyColumnTop: StyleParamType.Number;

  productPage_descriptionVisibleLineNumbers: StyleParamType.Number;
  productPage_galleryImageRatio: StyleParamType.Number;
  productPage_galleryImageMode: StyleParamType.Number;
  productPage_layoutId: StyleParamType.Number;
  productPage_infoSectionTypeId: StyleParamType.Number;
  productPage_infoSectionColumnNumber: StyleParamType.Number;
  productPage_subscriptionPlansOneTimePurchase: StyleParamType.Number;
  productPage_paymentOptionsBreakdownTheme: StyleParamType.Number;
  productPage_dynamicPaymentMethodsButtonTheme: StyleParamType.Number;
  productPage_dynamicPaymentMethodsButtonShape: StyleParamType.Number;
  productPage_addToCartAction: StyleParamType.Number;
  productPage_socialShareIconsTheme: StyleParamType.Number;
  productPage_spacingBetweenColumns: StyleParamType.Number;
  productPage_mainColumnRatio: StyleParamType.Number;

  productPage_galleryLayoutID: StyleParamType.Number;
  productPage_galleryImagesPerRow: StyleParamType.Number;
  productPage_gallerySpacingBetweenColumns: StyleParamType.Number;
  productPage_gallerySpacingBetweenRows: StyleParamType.Number;

  productPage_galleryImageBorderSize: StyleParamType.Number;
  productPage_galleryImageCornerRadius: StyleParamType.Number;
  productPage_galleryImageBorderStyleType: StyleParamType.Number;

  productPage_galleryNavigationLocation: StyleParamType.Font;
  productPage_galleryNavigationPosition: StyleParamType.Font;
  productPage_galleryNavigationType: StyleParamType.Font;
  productPage_selectedThumbnailBorderColor: StyleParamType.Color;
  productPage_selectedThumbnailBorderSize: StyleParamType.Number;
  productPage_selectedThumbnailCornerRadius: StyleParamType.Number;
  productPage_thumbnailImageRatio: StyleParamType.Number;
  productPage_thumbnailsSize: StyleParamType.Number;
  productPage_thumbnailsSpacing: StyleParamType.Number;
  productPage_infoSectionAlignment: StyleParamType.Font;
  productPage_descriptionFontStyle: StyleParamType.Font;
  productPage_infoSectionTextFontStyle: StyleParamType.Font;
  productPage_descriptionFontStyleOld: StyleParamType.Font;
  productPage_paragraphTitleFontStyle: StyleParamType.Font;
  quickView_infoSectionTitleFontStyle: StyleParamType.Font;
  productPage_infoSectionTitleFontStyle: StyleParamType.Font;
  productPage_paragraphTextFontStyle: StyleParamType.Font;
  productPage_productDetailsAlignment: StyleParamType.Font;
  productPage_stockIndicatorFontStyle: StyleParamType.Font;
  productPage_quantityFontStyle: StyleParamType.Font;
  productPage_quantityFont: StyleParamType.Font;
  quickView_descriptionFontStyle: StyleParamType.Font;
  quickView_discountNameFont: StyleParamType.Font;
  quickView_preOrderMessageFontStyle: StyleParamType.Font;
  productPage_optionsFontStyle: StyleParamType.Font;
  quickView_qtyAndOptionsFontStyle: StyleParamType.Font;
  productPage_discountNameFont: StyleParamType.Font;
  productPage_textualOptionType: StyleParamType.Number;
  productPage_buttonOptionsHorizontalPadding: StyleParamType.Number;
  productPage_buttonOptionsVerticalPadding: StyleParamType.Number;
  productPage_buttonOptionHoverTextColor: StyleParamType.Color;
  productPage_buttonOptionHoverBorderColor: StyleParamType.Color;
  productPage_buttonOptionHoverBackgroundColor: StyleParamType.Color;
  productPage_buttonOptionHoverFontStyle: StyleParamType.Font;
  productPage_buttonOptionDisabledBackgroundColor: StyleParamType.Color;
  productPage_buttonOptionDisabledBorderColor: StyleParamType.Color;
  productPage_buttonOptionDisabledTextColor: StyleParamType.Color;
  productPage_buttonOptionDisabledFontStyle: StyleParamType.Font;
  productPage_buttonOptionSelectedBackgroundColor: StyleParamType.Color;
  productPage_buttonOptionSelectedBorderColor: StyleParamType.Color;
  productPage_buttonOptionSelectedTextColor: StyleParamType.Color;
  productPage_buttonOptionSelectedFontStyle: StyleParamType.Font;
  productPage_quantityBackgroundOpacity: StyleParamType.Number;
  productPage_quantityBorderOpacity: StyleParamType.Number;
  productPage_quantityBorderWidth: StyleParamType.Number;
  productPage_quantityBoxWidth: StyleParamType.Number;
  productPage_quantityBoxCornerRadius: StyleParamType.Number;

  productPage_buttonOptionBorderRadius: StyleParamType.Number;
  productPage_buttonOptionTextColor: StyleParamType.Color;
  productPage_buttonOptionFontStyle: StyleParamType.Font;
  productPage_buttonOptionBorderWidth: StyleParamType.Number;
  productPage_buttonOptionBackgroundColor: StyleParamType.Color;
  productPage_buttonOptionsGap: StyleParamType.Number;
  productPage_buttonOptionBorderColor: StyleParamType.Color;
  productPage_buttonOptionWidth: StyleParamType.Number;
  productPage_buttonOptionsColumnsNumber: StyleParamType.Number;
  productPage_buttonOptionsColumnSpacing: StyleParamType.Number;
  productPage_buttonOptionTextAlignment: StyleParamType.Font;

  const_productPage_PageTitle_16px: StyleParamType.Font;
  const_productPage_PageTitle_32px: StyleParamType.Font;
  const_productPage_BodyM_12px: StyleParamType.Font;
  const_productPage_BodyM_14px: StyleParamType.Font;
  const_productPage_BodyM_16px: StyleParamType.Font;
  const_productPage_BodyM_20px: StyleParamType.Font;
  const_productPage_BodyM_24px: StyleParamType.Font;
  const_productPage_BodyM_26px: StyleParamType.Font;
  const_productPage_BodyM_32px: StyleParamType.Font;
  productPage_infoSectionTextColor: StyleParamType.Color;
  productPage_descriptionTextColor: StyleParamType.Color;
  productPage_paragraphTextColor: StyleParamType.Color;
  productPage_mediaNavigationArrowsColor: StyleParamType.Color;
  quickView_descriptionTextColor: StyleParamType.Color;
  productPage_descriptionAlignment: StyleParamType.Font;
  productPage_infoSectionTableZebraColor1: StyleParamType.Color;
  productPage_infoSectionTableZebraColor2: StyleParamType.Color;
  productPage_infoSectionTableBorderColor: StyleParamType.Color;
  productPage_actionButtonborderSize: StyleParamType.Font;
  addToCart_actionButtonborderSize: StyleParamType.Font;
  quickView_buttonborderSize: StyleParamType.Font;
  productPage_buyNowButtonBorderSize: StyleParamType.Font;
  productPage_buyNowButtonBackgroundColor: StyleParamType.Color;
  quickView_infoSectionLineColor: StyleParamType.Color;
  productPage_infoSectionLineColor: StyleParamType.Color;
  addToCart_actionButtontextColor: StyleParamType.Color;
  quickView_mainButtonTextColor: StyleParamType.Color;
  quickView_buttontextColor: StyleParamType.Color;
  productPage_mainButtonTextColor: StyleParamType.Color;
  productPage_actionButtontextColor: StyleParamType.Color;
  addToCart_actionButtonbackgroundColor: StyleParamType.Color;
  quickView_mainButtonBackground: StyleParamType.Color;
  quickView_buttonbackgroundColor: StyleParamType.Color;
  productPage_mainButtonBackground: StyleParamType.Color;
  productPage_actionButtonbackgroundColor: StyleParamType.Color;
  addToCart_actionButtonborderColor: StyleParamType.Color;
  quickView_buttonborderColor: StyleParamType.Color;
  productPage_actionButtonborderColor: StyleParamType.Color;
  addToCart_actionButtontextFont: StyleParamType.Font;
  quickView_mainButtonFontStyle: StyleParamType.Font;
  quickView_buttontextFont: StyleParamType.Font;
  productPage_mainButtonFontStyle: StyleParamType.Font;
  productPage_actionButtontextFont: StyleParamType.Font;
  productPage_buyNowButtonTextFont: StyleParamType.Font;
  addToCart_actionButtoncornersRadius: StyleParamType.Font;
  quickView_buttoncornersRadius: StyleParamType.Font;
  productPage_actionButtoncornersRadius: StyleParamType.Font;
  productPage_buyNowButtonCornersRadius: StyleParamType.Font;
  productPage_buyNowButtonBorderColor: StyleParamType.Color;
  productPage_buyNowButtonTextColor: StyleParamType.Color;

  productPage_discountNameColor: StyleParamType.Color;
  productPage_priceColor: StyleParamType.Color;
  productPage_strikethroughPriceColor: StyleParamType.Color;
  productPage_salePriceColor: StyleParamType.Color;
  productPage_background: StyleParamType.Color;
  productPage_optionsColor: StyleParamType.Color;
  productPage_quantityColor: StyleParamType.Color;
  productPage_quantityBackgroundColor: StyleParamType.Color;
  productPage_quantityBorderColor: StyleParamType.Color;
  productPage_stockIndicatorColor: StyleParamType.Color;
  productPage_preOrderMessageColor: StyleParamType.Color;
  quickView_preOrderMessageColor: StyleParamType.Color;
  productPage_skuColor: StyleParamType.Color;
  productPage_titleTextColor: StyleParamType.Color;
  productPage_paragraphTitleColor: StyleParamType.Color;
  productPage_infoSectionTitleTextColor: StyleParamType.Color;
  quickView_infoSectionTitleTextColor: StyleParamType.Color;
  productPage_subscriptionPlansBoxColor: StyleParamType.Color;
  productPage_unitPriceColor: StyleParamType.Color;
  productPage_subscriptionPlanFrequencyColor: StyleParamType.Color;
  quickView_subscriptionPlanFrequencyColor: StyleParamType.Color;
  productPage_headerStripBackgroundColor: StyleParamType.Color;
  productPage_footerStripBackgroundColor: StyleParamType.Color;
  productPage_detailsBoxBackgroundColor: StyleParamType.Color;
  productPage_colorSwatchSize: StyleParamType.Number;
  productPage_colorSwatchCornerRadius: StyleParamType.Number;

  productPage_galleryBorderColor: StyleParamType.Color;
  productPage_mainImageBorderSize: StyleParamType.Number;
  productPage_mainImageCornerRadius: StyleParamType.Number;

  productPage_dropdownListBackgroundOpacityColor: StyleParamType.Color;
  productPage_dropdownListTextFont: StyleParamType.Font;
  productPage_dropdownListTextColor: StyleParamType.Color;
  productPage_dropdownListBorderOpacityColor: StyleParamType.Color;
  productPage_dropdownListBorderWidth: StyleParamType.Number;
  productPage_dropdownListCornerRadius: StyleParamType.Number;
  productPage_dropdownListWidth: StyleParamType.Number;

  productPage_priceFontStyle: StyleParamType.Font;
  productPage_strikethroughPriceFontStyle: StyleParamType.Font;
  productPage_salePriceFontStyle: StyleParamType.Font;
  productPage_titleFontStyle: StyleParamType.Font;
  productPage_skuFontStyle: StyleParamType.Font;
  productPage_preOrderMessageFontStyle: StyleParamType.Font;
  productPage_unitPriceFontStyle: StyleParamType.Font;
  productPage_subscriptionPlanFrequencyFontStyle: StyleParamType.Font;
  quickView_subscriptionPlanFrequencyFontStyle: StyleParamType.Font;
  quickView_textualOptionType: StyleParamType.Number;
  productPage_subscriptionsFont: StyleParamType.Font;
  productPage_subscriptionsTextColor: StyleParamType.Color;

  productPage_subscriptionRegularBoxBackgroundColor: StyleParamType.Color;
  productPage_subscriptionRegularBorderColor: StyleParamType.Color;
  productPage_subscriptionRegularBorderWidth: StyleParamType.Number;
  productPage_subscriptionRegularBorderCornerRadius: StyleParamType.Number;
  productPage_subscriptionRegularContainerWidth: StyleParamType.Number;
  productPage_subscriptionRegularNameFont: StyleParamType.Font;
  productPage_subscriptionRegularNameColor: StyleParamType.Color;
  productPage_subscriptionRegularTaglineFont: StyleParamType.Font;
  productPage_subscriptionRegularTaglineColor: StyleParamType.Color;
  productPage_subscriptionRegularPriceFont: StyleParamType.Font;
  productPage_subscriptionRegularPriceColor: StyleParamType.Color;
  productPage_subscriptionRegularFrequencyFont: StyleParamType.Font;
  productPage_subscriptionRegularFrequencyColor: StyleParamType.Color;

  productPage_subscriptionSelectedBoxBackgroundColor: StyleParamType.Color;
  productPage_subscriptionSelectedBorderColor: StyleParamType.Color;
  productPage_subscriptionSelectedBorderWidth: StyleParamType.Number;
  productPage_subscriptionSelectedNameFont: StyleParamType.Font;
  productPage_subscriptionSelectedNameColor: StyleParamType.Color;
  productPage_subscriptionSelectedTaglineFont: StyleParamType.Font;
  productPage_subscriptionSelectedTaglineColor: StyleParamType.Color;
  productPage_subscriptionSelectedPriceFont: StyleParamType.Font;
  productPage_subscriptionSelectedPriceColor: StyleParamType.Color;
  productPage_subscriptionSelectedFrequencyFont: StyleParamType.Font;
  productPage_subscriptionSelectedFrequencyColor: StyleParamType.Color;

  productPage_optionsAlignment: StyleParamType.Font;
  productPage_quantityAlignment: StyleParamType.Font;
  productPage_priceAlignment: StyleParamType.Font;
  productPage_socialMediaAlignment: StyleParamType.Font;
  productPage_titleAlignment: StyleParamType.Font;

  productPage_wishlistIconFillColor: StyleParamType.Color;
  productPage_wishlistIconBorderSize: StyleParamType.Font;
  productPage_wishlistButtonCornersRadius: StyleParamType.Font;
  productPage_wishlistButtonBorderSize: StyleParamType.Font;
  productPage_wishlistButtonBackgroundColor: StyleParamType.Color;
  productPage_wishlistButtonBorderColor: StyleParamType.Color;
  productPage_wishlistButtonTextColor: StyleParamType.Color;
  productPage_wishlistButtonTextFont: StyleParamType.Font;

  quickView_priceColor: StyleParamType.Color;
  quickView_priceFontStyle: StyleParamType.Font;
  quickView_background: StyleParamType.Color;
  quickView_thumbnailBorder: StyleParamType.Color;
  quickView_galleryBorderColor: StyleParamType.Color;
  quickView_qtyAndOptionsColor: StyleParamType.Color;
  quickView_titleTextColor: StyleParamType.Color;
  quickView_titleFontStyle: StyleParamType.Font;
  quickView_skuColor: StyleParamType.Color;
  quickView_skuFontStyle: StyleParamType.Font;
};

const responsive = createStylesParam('responsive', {
  type: StyleParamType.Boolean,
  getDefaultValue: ({isEditorX}) => isEditorX,
});

const quickView_qtyAndOptionsFontStyle = createStylesParam('quickView_qtyAndOptionsFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M', // TODO: editor 3 - used Body-M as default but found font sizes varying between 14px and 15px in OptionsDropdown.st.css
    },
  },
});

const quickView_preOrderMessageFontStyle = createStylesParam('quickView_preOrderMessageFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 14,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
});

const quickView_descriptionFontStyle = createStylesParam('quickView_descriptionFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M'),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
    },
  },
});

const quickView_infoSectionTextFontStyle = createStylesParam('quickView_infoSectionTextFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_paragraphTextFontStyle),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'ref',
      ref: 'productPage_paragraphTextFontStyle',
    },
  },
});
const productPage_textualOptionType = createStylesParam('productPage_textualOptionType', {
  type: StyleParamType.Number,
  metadata: {
    type: StyleType.numberEnum,
    ai: {
      description: 'controls how textual product options are displayed: dropdown (1) or buttons (2)',
    },
    defaultValue: {
      type: 'static',
      value: TextualOptionType.DROPDOWN,
    },
  },
});

const productPage_buttonOptionsHorizontalPadding = createStylesParam('productPage_buttonOptionsHorizontalPadding', {
  type: StyleParamType.Number,
  getDefaultValue: () => 8,
  metadata: {
    type: StyleType.padding,
    defaultValue: {
      type: 'static',
      value: 8,
    },
  },
});

const productPage_buttonOptionsVerticalPadding = createStylesParam('productPage_buttonOptionsVerticalPadding', {
  type: StyleParamType.Number,
  getDefaultValue: () => 4,
  metadata: {
    type: StyleType.padding,
    defaultValue: {
      type: 'static',
      value: 8,
    },
  },
});

const productPage_buttonOptionBorderRadius = createStylesParam('productPage_buttonOptionBorderRadius', {
  type: StyleParamType.Number,
  getDefaultValue: () => 0,
  metadata: {
    type: StyleType.borderRadius,
    defaultValue: {
      type: 'static',
      value: 0,
    },
  },
});

const productPage_buttonOptionTextColor = createStylesParam('productPage_buttonOptionTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const productPage_buttonOptionFontStyle = createStylesParam('productPage_buttonOptionFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 14,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
    },
  },
});

const productPage_buttonOptionBorderWidth = createStylesParam('productPage_buttonOptionBorderWidth', {
  type: StyleParamType.Number,
  getDefaultValue: () => 1,
  metadata: {
    type: StyleType.borderWidth,
    defaultValue: {
      type: 'static',
      value: 1,
    },
  },
});

const productPage_buttonOptionBackgroundColor = createStylesParam('productPage_buttonOptionBackgroundColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-1'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
});

const productPage_buttonOptionBorderColor = createStylesParam('productPage_buttonOptionBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const productPage_buttonOptionDisabledBorderColor = createStylesParam('productPage_buttonOptionDisabledBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-3'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstSystemDisabledColor),
  },
});

const productPage_buttonOptionDisabledTextColor = createStylesParam('productPage_buttonOptionDisabledTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-3'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstSystemDisabledColor),
  },
});

const productPage_buttonOptionDisabledFontStyle = createStylesParam('productPage_buttonOptionDisabledFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 14,
  }),
});

const productPage_buttonOptionSelectedBackgroundColor = createStylesParam(
  'productPage_buttonOptionSelectedBackgroundColor',
  {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  }
);

const productPage_buttonOptionSelectedBorderColor = createStylesParam('productPage_buttonOptionSelectedBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const productPage_buttonOptionSelectedTextColor = createStylesParam('productPage_buttonOptionSelectedTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-1'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
});

const productPage_buttonOptionSelectedFontStyle = createStylesParam('productPage_buttonOptionSelectedFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 14,
  }),
});

const productPage_buttonOptionHoverFontStyle = createStylesParam('productPage_buttonOptionHoverFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 14,
  }),
});

const productPage_buttonOptionsGap = createStylesParam('productPage_buttonOptionsGap', {
  type: StyleParamType.Number,
  getDefaultValue: () => 8,
  metadata: {
    type: StyleType.gap,
    defaultValue: {
      type: 'static',
      value: 8,
    },
  },
});

const productPage_buttonOptionHoverBackgroundColor = createStylesParam('productPage_buttonOptionHoverBackgroundColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-1'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
});

const productPage_buttonOptionWidth = createStylesParam('productPage_buttonOptionWidth', {
  type: StyleParamType.Number,
  getDefaultValue: () => ButtonOptionWidth.FIT,
  metadata: {
    type: StyleType.numberEnum,
    ai: {
      description: 'controls button option width: fit to content (1) or stretch to fill - grid layout (2)',
    },
    defaultValue: {
      type: 'static',
      value: ButtonOptionWidth.FIT,
    },
  },
});

const productPage_buttonOptionsColumnsNumber = createStylesParam('productPage_buttonOptionsColumnsNumber', {
  type: StyleParamType.Number,
  getDefaultValue: () => 3,
  metadata: {
    type: StyleType.number,
    defaultValue: {
      type: 'static',
      value: 3,
    },
  },
});

const productPage_buttonOptionsColumnSpacing = createStylesParam('productPage_buttonOptionsColumnSpacing', {
  type: StyleParamType.Number,
  getDefaultValue: () => 8,
  metadata: {
    type: StyleType.gap,
    defaultValue: {
      type: 'static',
      value: 8,
    },
  },
});

const productPage_buttonOptionTextAlignment = createStylesParam('productPage_buttonOptionTextAlignment', {
  type: StyleParamType.Font,
  getDefaultValue: () => ({
    fontStyleParam: false,
    value: Alignment.CENTER,
  }),
  metadata: {
    type: StyleType.legacyFontStyleParamEnum,
    defaultValue: {
      type: 'static',
      value: Alignment.CENTER,
    },
  },
});

const productPage_quantityBackgroundOpacity = createStylesParam('productPage_quantityBackgroundOpacity', {
  type: StyleParamType.Number,
  getDefaultValue: () => 100,
  metadata: {
    type: StyleType.numberEnum,
    defaultValue: {
      type: 'static',
      value: 100,
    },
  },
});

const productPage_buttonOptionHoverBorderColor = createStylesParam('productPage_buttonOptionHoverBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const productPage_quantityBorderOpacity = createStylesParam('productPage_quantityBorderOpacity', {
  type: StyleParamType.Number,
  getDefaultValue: () => 100,
  metadata: {
    type: StyleType.numberEnum,
    defaultValue: {
      type: 'static',
      value: 100,
    },
  },
});

const productPage_buttonOptionDisabledBackgroundColor = createStylesParam(
  'productPage_buttonOptionDisabledBackgroundColor',
  {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  }
);

const productPage_buttonOptionHoverTextColor = createStylesParam('productPage_buttonOptionHoverTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const productPage_quantityBorderWidth = createStylesParam('productPage_quantityBorderWidth', {
  type: StyleParamType.Number,
  getDefaultValue: () => 1,
  metadata: {
    type: StyleType.borderWidth,
    defaultValue: {
      type: 'static',
      value: 1,
    },
  },
});

const productPage_quantityBoxWidth = createStylesParam('productPage_quantityBoxWidth', {
  type: StyleParamType.Number,
  getDefaultValue: () => 20,
  metadata: {
    type: StyleType.width,
    defaultValue: {
      type: 'static',
      value: 20,
    },
  },
});

const productPage_quantityBoxCornerRadius = createStylesParam('productPage_quantityBoxCornerRadius', {
  type: StyleParamType.Number,
  getDefaultValue: () => 0,
  metadata: {
    type: StyleType.borderRadius,
    defaultValue: {
      type: 'static',
      value: 0,
    },
  },
});

const productPage_paragraphTextColor = createStylesParam('productPage_paragraphTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const quickView_descriptionTextColor = createStylesParam('quickView_descriptionTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_paragraphTextColor),
  metadata: {
    type: StyleType.color,
    defaultValue: {
      type: 'ref',
      ref: 'productPage_paragraphTextColor',
    },
  },
});

const quickView_infoSectionTextColor = createStylesParam('quickView_infoSectionTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_paragraphTextColor),
  metadata: {
    type: StyleType.color,
    defaultValue: {
      type: 'ref',
      ref: 'productPage_paragraphTextColor',
    },
  },
});

const productPage_paragraphTextFontStyle = createStylesParam('productPage_paragraphTextFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M', // TODO: editor 3 - verify fallback, assumed Body-M based on naming convention
    },
  },
});

const productPage_descriptionTextColor = createStylesParam('productPage_descriptionTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_descriptionTextColor),
  metadata: {
    type: StyleType.color,
    defaultValue: {
      type: 'ref',
      ref: 'quickView_descriptionTextColor',
    },
  },
});

const quickView_buttonborderSize = createStylesParam('quickView_buttonborderSize', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(addToCart_actionButtonborderSize),
  metadata: {
    type: StyleType.legacyFontStyleParamEnum,
    defaultValue: {
      type: 'ref',
      ref: 'addToCart_actionButtonborderSize',
    },
  },
});

const addToCart_actionButtonborderSize = createStylesParam('addToCart_actionButtonborderSize', {
  type: StyleParamType.Font,
  getDefaultValue: () => ({
    fontStyleParam: false,
    value: '0px',
  }),
  metadata: {
    type: StyleType.legacyFontStyleParamEnum,
    defaultValue: {
      type: 'static',
      value: 0,
    },
  },
});

const quickView_infoSectionLineColor = createStylesParam('quickView_infoSectionLineColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-3'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstSystemDisabledColor),
  },
});

const addToCart_actionButtontextColor = createStylesParam('addToCart_actionButtontextColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-1'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
});

const quickView_mainButtonTextColor = createStylesParam('quickView_mainButtonTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(addToCart_actionButtontextColor),
});

const quickView_buttontextColor = createStylesParam('quickView_buttontextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_mainButtonTextColor),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
});

const productPage_mainButtonTextColor = createStylesParam('productPage_mainButtonTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_buttontextColor),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
});

const addToCart_actionButtonbackgroundColor = createStylesParam('addToCart_actionButtonbackgroundColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-8'),
  metadata: {
    type: StyleType.backgroundColor,
    defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
  },
});

const quickView_mainButtonBackground = createStylesParam('quickView_mainButtonBackground', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(addToCart_actionButtonbackgroundColor),
});

const quickView_buttonbackgroundColor = createStylesParam('quickView_buttonbackgroundColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_mainButtonBackground),
});

const productPage_mainButtonBackground = createStylesParam('productPage_mainButtonBackground', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_buttonbackgroundColor),
});

const addToCart_actionButtonborderColor = createStylesParam('addToCart_actionButtonborderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.borderColor,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const quickView_buttonborderColor = createStylesParam('quickView_buttonborderColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(addToCart_actionButtonborderColor),
});

const addToCart_actionButtontextFont = createStylesParam('addToCart_actionButtontextFont', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 16,
  }),
});

const quickView_mainButtonFontStyle = createStylesParam('quickView_mainButtonFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(addToCart_actionButtontextFont),
});

const quickView_buttontextFont = createStylesParam('quickView_buttontextFont', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_mainButtonFontStyle),
});

const productPage_mainButtonFontStyle = createStylesParam('productPage_mainButtonFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_buttontextFont),
});

const productPage_actionButtontextFont = createStylesParam('productPage_actionButtontextFont', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_mainButtonFontStyle),
});

const addToCart_actionButtoncornersRadius = createStylesParam('addToCart_actionButtoncornersRadius', {
  type: StyleParamType.Font,
  getDefaultValue: () => ({
    fontStyleParam: false,
    value: '0px',
  }),
  metadata: {
    type: StyleType.legacyFontStyleParamEnum,
    defaultValue: {
      type: 'static',
      value: '0px',
    },
  },
});

const quickView_buttoncornersRadius = createStylesParam('quickView_buttoncornersRadius', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(addToCart_actionButtoncornersRadius),
  metadata: {
    type: StyleType.legacyFontStyleParamEnum,
    defaultValue: {
      type: 'ref',
      ref: 'addToCart_actionButtoncornersRadius',
    },
  },
});

const productPage_actionButtoncornersRadius = createStylesParam('productPage_actionButtoncornersRadius', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_buttoncornersRadius),
  metadata: {
    type: StyleType.legacyFontStyleParamEnum,
    defaultValue: {
      type: 'ref',
      ref: 'quickView_buttoncornersRadius',
    },
  },
});

const quickView_qtyAndOptionsColor = createStylesParam('quickView_qtyAndOptionsColor', {
  type: StyleParamType.Color,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const quickView_background = createStylesParam('quickView_background', {
  type: StyleParamType.Color,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor), // TODO: editor 3 - verify fallback
  },
});

const quickView_titleTextColor = createStylesParam('quickView_titleTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const quickView_skuColor = createStylesParam('quickView_skuColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-4'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph3Color),
  },
});

const quickView_skuFontStyle = createStylesParam('quickView_skuFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {
    size: 12,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 12,
    },
  },
});

const productPage_paragraphTitleColor = createStylesParam('productPage_paragraphTitleColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const quickView_infoSectionTitleTextColor = createStylesParam('quickView_infoSectionTitleTextColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_paragraphTitleColor),
  metadata: {
    type: StyleType.color,
    defaultValue: {
      type: 'ref',
      ref: 'productPage_paragraphTitleColor',
    },
  },
});

const quickView_galleryBorderColor = createStylesParam('quickView_galleryBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-2'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstSecondaryBackgroundColor),
  },
});

const quickView_subscriptionPlanFrequencyColor = createStylesParam('quickView_subscriptionPlanFrequencyColor', {
  type: StyleParamType.Color,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph3Color), // TODO: editor 3 - verify fallback
  },
});

const quickView_priceFontStyle = createStylesParam('quickView_priceFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
    },
  },
});

const quickView_subscriptionPlanFrequencyFontStyle = createStylesParam('quickView_subscriptionPlanFrequencyFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 12,
    },
  },
});

const quickView_textualOptionType = createStylesParam('quickView_textualOptionType', {
  type: StyleParamType.Number,
  getDefaultValue: () => TextualOptionType.DROPDOWN,
  metadata: {
    type: StyleType.numberEnum,
    defaultValue: {
      type: 'static',
      value: TextualOptionType.DROPDOWN,
    },
  },
});

const quickView_preOrderMessageColor = createStylesParam('quickView_preOrderMessageColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});

const productPage_priceColor = createStylesParam('productPage_priceColor', {
  type: StyleParamType.Color,
  getDefaultValue: () => undefined,
  metadata: {
    type: StyleType.color,
    defaultValue: {
      type: 'ref',
      ref: 'quickView_priceColor',
    },
  },
});

const productPage_priceFontStyle = createStylesParam('productPage_priceFontStyle', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_priceFontStyle),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'ref',
      ref: 'quickView_priceFontStyle',
    },
  },
});

const productPage_layoutId = createStylesParam('productPage_layoutId', {
  type: StyleParamType.Number,
  inheritDesktop: false,
  getDefaultValue: ({getStyleParamValue, isMobile}) =>
    isMobile || getStyleParamValue(responsive) ? LayoutId.Responsive : LayoutId.Classic,
  metadata: {
    type: StyleType.numberEnum,
    ai: {
      description:
        'controls product page layout: classic (1), sleek (4), stunning (5), spotlight (6), simple (7), or modern (8)',
    },
    defaultValue: {
      type: 'static',
      value: LayoutId.Responsive,
    },
  },
});

const productPage_subscriptionRegularBoxBackgroundColor = createStylesParam(
  'productPage_subscriptionRegularBoxBackgroundColor',
  {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  }
);
const productPage_subscriptionRegularBorderColor = createStylesParam('productPage_subscriptionRegularBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.borderColor,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});
const productPage_subscriptionRegularBorderWidth = createStylesParam('productPage_subscriptionRegularBorderWidth', {
  type: StyleParamType.Number,
  getDefaultValue: () => 1,
  metadata: {
    type: StyleType.borderWidth,
    defaultValue: {type: 'static', value: 1},
  },
});
const productPage_subscriptionRegularNameFont = createStylesParam('productPage_subscriptionRegularNameFont', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {size: 16}),
  metadata: {
    type: StyleType.font,
    defaultValue: {type: 'static', preset: 'Body-M', size: 16},
  },
});
const productPage_subscriptionRegularNameColor = createStylesParam('productPage_subscriptionRegularNameColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});
const productPage_subscriptionRegularTaglineFont = createStylesParam('productPage_subscriptionRegularTaglineFont', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {size: 12}),
  metadata: {
    type: StyleType.font,
    defaultValue: {type: 'static', preset: 'Body-M', size: 12},
  },
});
const productPage_subscriptionRegularTaglineColor = createStylesParam('productPage_subscriptionRegularTaglineColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});
const productPage_subscriptionRegularPriceFont = createStylesParam('productPage_subscriptionRegularPriceFont', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {size: 16}),
  metadata: {
    type: StyleType.font,
    defaultValue: {type: 'static', preset: 'Body-M', size: 16},
  },
});
const productPage_subscriptionRegularPriceColor = createStylesParam('productPage_subscriptionRegularPriceColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
});
const productPage_subscriptionRegularFrequencyFont = createStylesParam('productPage_subscriptionRegularFrequencyFont', {
  type: StyleParamType.Font,
  getDefaultValue: wixFontParam('Body-M', {size: 12}),
  metadata: {
    type: StyleType.font,
    defaultValue: {type: 'static', preset: 'Body-M', size: 12},
  },
});
const productPage_subscriptionRegularFrequencyColor = createStylesParam(
  'productPage_subscriptionRegularFrequencyColor',
  {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  }
);

const productPage_buyNowButtonEnabled = createStylesParam('productPage_buyNowButtonEnabled', {
  type: StyleParamType.Boolean,
  getDefaultValue: () => false,
  metadata: {
    type: StyleType.booleanValue,
    defaultValue: {
      type: 'static',
      value: false,
    },
  },
});

const productPage_productAction = createStylesParam('productPage_productAction', {
  type: StyleParamType.Boolean,
  getDefaultValue: () => true,
  metadata: {
    type: StyleType.booleanValue,
    defaultValue: {
      type: 'static',
      value: true,
    },
  },
});

const stylesParams: IStylesParams = {
  full_width: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  productPage_buyNowButtonEnabled,
  productPage_galleryZoom: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_infoSectionShowDeviders: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_navigation: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue, isMobile}) => {
      const isResponsive = getStyleParamValue(responsive);
      return isResponsive && isMobile ? true : !isResponsive;
    },
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true, // TODO: Editor 3 - verify what the requested default should be
      },
    },
  },
  productPage_breadcrumbsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_descriptionTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_descriptionTextColor',
      },
    },
  },
  productPage_breadcrumbsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      lineHeight: '1.5em' as any,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  productPage_openMinicart: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_paymentOptionsBreakdown: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_productAction,
  productPage_stickyContainerEnabled: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_productAction),
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_productAction',
      },
    },
  },
  productPage_productInfoSection: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_stockIndicator: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  productPage_productPrice: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_showDiscountName: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_productQuantity: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_productSku: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_socialNetworkwhatsapp: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_socialNetworkfacebook: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_socialNetworkpinterest: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_socialNetworks: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_socialNetworktwitter: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  productPage_wishlistEnabled: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  productPage_dynamicPaymentMethodsEnabled: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  productPage_flipColumns: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },

  responsive,

  productPage_descriptionVisibleLineNumbers: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_galleryImageRatio: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => ImageRatio.AUTO,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls product image aspect ratio: auto (-1), 3:2 (0), 4:3 (1), 1:1 (2), 3:4 (3), or 2:3 (4)',
      },
      defaultValue: {
        type: 'static',
        value: ImageRatio.AUTO,
      },
    },
  },
  productPage_galleryImageMode: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageModeValues.CROP,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls how product images are resized: crop to fill (1) or fit within bounds (2)',
      },
      defaultValue: {
        type: 'static',
        value: ImageModeValues.CROP,
      },
    },
  },
  productPage_layoutId,
  productPage_infoSectionTypeId: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: () => InfoSectionLayoutId.Collapse,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls info section layout: collapse (1), tabs (2), stacked rows (3), or columns (4)',
      },
      defaultValue: {
        type: 'static',
        value: InfoSectionLayoutId.Collapse,
      },
    },
  },
  productPage_infoSectionColumnNumber: {
    type: StyleParamType.Number,
    inheritDesktop: false,
    getDefaultValue: ({isMobile}) => (isMobile ? 3 : 1),
  },
  productPage_subscriptionPlansOneTimePurchase: {
    type: StyleParamType.Number,
    getDefaultValue: () => SubscriptionPlansOneTimePurchaseOptionLocation.FIRST,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description:
          'when a subsription product is available for one-time purchase controls the placement of the one-time purchase: first (0) or last (1)',
      },
      defaultValue: {
        type: 'static',
        value: SubscriptionPlansOneTimePurchaseOptionLocation.FIRST,
      },
    },
  },
  productPage_paymentOptionsBreakdownTheme: {
    type: StyleParamType.Number,
    getDefaultValue: () => PaymentOptionsBreakdownTheme.LIGHT,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls the theme of the payment options breakdown: light (1) or dark (2)',
      },
      defaultValue: {
        type: 'static',
        value: PaymentOptionsBreakdownTheme.LIGHT,
      },
    },
  },
  productPage_dynamicPaymentMethodsButtonTheme: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls the theme of the smart payment buttons: light (0) or dark (1)',
      },
      defaultValue: {
        type: 'static',
        value: DynamicPaymentMethodsTheme.light, // TODO: editor 3 - what is the default value?
      },
    },
  },
  productPage_addToCartAction: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description:
          'controls add to cart action behavior: success popup (0), open mini cart (1), navigate to cart page (2), or stay on product page (3)',
      },
      defaultValue: {
        type: 'static',
        value: AddToCartActionOption.MINI_CART,
      },
    },
  },
  productPage_dynamicPaymentMethodsButtonShape: {
    type: StyleParamType.Number,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls dynamic payment methods button shape: rectangle (0) or pill (1)',
      },
      defaultValue: {
        type: 'static',
        value: DynamicPaymentMethodsShape.rect,
      },
    },
  },
  productPage_socialShareIconsTheme: {
    type: StyleParamType.Number,
    getDefaultValue: () => SocialShareIconsTheme.ORIGINAL,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls social share icons theme: original (0), dark (1), or light (2)',
      },
      defaultValue: {
        type: 'static',
        value: SocialShareIconsTheme.ORIGINAL,
      },
    },
  },
  productPage_spacingBetweenColumns: {
    type: StyleParamType.Number,
    getDefaultValue: () => 32,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 32,
      },
    },
  },
  productPage_mainColumnRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => 50,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 50,
      },
    },
  },
  productPage_galleryLayoutID: {
    type: StyleParamType.Number,
    getDefaultValue: () => GalleryLayoutID.MainImage,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls gallery layout in product page: thumbnail layout (1) or grid layout (2)',
      },
      defaultValue: {
        type: 'static',
        value: GalleryLayoutID.MainImage,
      },
    },
  },
  productPage_galleryImagesPerRow: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 2,
      },
    },
  },
  productPage_gallerySpacingBetweenColumns: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 12,
      },
    },
  },
  productPage_gallerySpacingBetweenRows: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 12,
      },
    },
  },
  productPage_galleryImageBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_galleryImageCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },

  productPage_galleryNavigationLocation: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: GalleryNavigationLocation.OUTSIDE,
    }),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: GalleryNavigationLocation.OUTSIDE,
      },
    },
  },
  productPage_galleryNavigationPosition: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: GalleryNavigationPosition.BOTTOM,
    }),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: GalleryNavigationPosition.BOTTOM,
      },
    },
  },
  productPage_galleryNavigationType: {
    type: StyleParamType.Font,
    inheritDesktop: false,
    getDefaultValue: ({isMobile}) => ({
      fontStyleParam: false,
      value: isMobile ? GalleryNavigationType.DOTS : GalleryNavigationType.THUMBNAILS,
    }),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: GalleryNavigationType.THUMBNAILS,
      },
      mobileDefaultValue: {
        type: 'static',
        value: GalleryNavigationType.DOTS,
      },
    },
  },
  productPage_selectedThumbnailBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  productPage_selectedThumbnailBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  productPage_selectedThumbnailCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_thumbnailImageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => ImageRatio.ONE_BY_ONE,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: ImageRatio.ONE_BY_ONE,
      },
    },
  },
  productPage_thumbnailsSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 45,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  productPage_thumbnailsSpacing: {
    type: StyleParamType.Number,
    getDefaultValue: () => 6,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 6,
      },
    },
  },
  productPage_infoSectionAlignment: {
    type: StyleParamType.Font,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: Alignment.START,
    }),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: Alignment.START,
      },
    },
  },
  quickView_descriptionFontStyle,
  productPage_descriptionFontStyleOld: createStylesParam('productPage_descriptionFontStyle', {
    type: StyleParamType.Font,
  }),
  productPage_descriptionAlignment: {
    type: StyleParamType.Font,
    getDefaultValue: ({isRTL}) => ({
      fontStyleParam: false,
      value: isRTL ? Alignment.RIGHT : Alignment.LEFT,
    }),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: Alignment.START,
      },
    },
  },
  productPage_descriptionFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_descriptionFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_descriptionFontStyle',
      },
    },
  },
  productPage_infoSectionTextFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_infoSectionTextFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_infoSectionTextFontStyle',
      },
    },
  },
  productPage_infoSectionTitleFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_infoSectionTitleFontStyle', // TODO: editor 3 - based on InfoSectionTitle.st.css where it references both parameters
      },
    },
  },
  quickView_infoSectionTitleFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_paragraphTitleFontStyle', // TODO: editor 3 - verify
      },
    },
  },
  productPage_paragraphTitleFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M', // TODO: editor 3 - verify fallback, multiple references in CSS files with varying values (Body-M or Page-title-16px)
      },
    },
  },
  productPage_productDetailsAlignment: {
    type: StyleParamType.Font,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: Alignment.START,
      },
    },
  },
  productPage_paragraphTextFontStyle,
  quickView_discountNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  productPage_quantityFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsFontStyle',
      },
    },
  },
  productPage_quantityFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsFontStyle',
      },
    },
  },
  productPage_stockIndicatorFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsFontStyle',
      },
    },
  },
  productPage_optionsFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsFontStyle',
      },
    },
  },
  quickView_qtyAndOptionsFontStyle,
  quickView_preOrderMessageFontStyle,
  productPage_discountNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  const_productPage_PageTitle_16px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {
      size: 16,
    }),
  },
  const_productPage_PageTitle_32px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {
      size: 32,
    }),
  },
  const_productPage_BodyM_14px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
  },
  const_productPage_BodyM_20px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 20,
    }),
  },
  const_productPage_BodyM_12px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 12,
    }),
  },
  const_productPage_BodyM_16px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  const_productPage_BodyM_24px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 24,
    }),
  },
  const_productPage_BodyM_26px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 26,
    }),
  },
  const_productPage_BodyM_32px: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 32,
    }),
  },
  productPage_paragraphTextColor,
  quickView_descriptionTextColor,
  productPage_descriptionTextColor,
  productPage_mediaNavigationArrowsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_descriptionTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_descriptionTextColor',
      },
    },
  },
  productPage_infoSectionTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_infoSectionTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_infoSectionTextColor',
      },
    },
  },
  productPage_infoSectionTableZebraColor1: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor), // TODO: editor 3 - verify fallback
    },
  },
  productPage_infoSectionTableZebraColor2: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_infoSectionTableBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstSystemDisabledColor),
    },
  },
  addToCart_actionButtonborderSize,
  quickView_buttonborderSize,
  productPage_actionButtonborderSize: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_buttonborderSize),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_buttonborderSize',
      },
    },
  },
  productPage_buyNowButtonBorderSize: {
    type: StyleParamType.Font,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: '0px',
    }),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'static',
        value: '0px',
      },
    },
  },
  productPage_buyNowButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  quickView_infoSectionLineColor,
  productPage_infoSectionLineColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_infoSectionLineColor),
  },
  addToCart_actionButtontextColor,
  quickView_mainButtonTextColor,
  quickView_buttontextColor,
  productPage_mainButtonTextColor,
  productPage_actionButtontextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_mainButtonTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  addToCart_actionButtonbackgroundColor,
  quickView_mainButtonBackground,
  quickView_buttonbackgroundColor,
  productPage_mainButtonBackground,
  productPage_actionButtonbackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_mainButtonBackground),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  addToCart_actionButtonborderColor,
  quickView_buttonborderColor,
  productPage_actionButtonborderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_buttonborderColor),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  addToCart_actionButtontextFont,
  quickView_mainButtonFontStyle,
  quickView_buttontextFont,
  productPage_mainButtonFontStyle,
  productPage_actionButtontextFont,
  productPage_buyNowButtonTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_actionButtontextFont),
  },
  addToCart_actionButtoncornersRadius,
  quickView_buttoncornersRadius,
  productPage_actionButtoncornersRadius,
  productPage_buyNowButtonCornersRadius: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_actionButtoncornersRadius),
    metadata: {
      type: StyleType.legacyFontStyleParamEnum,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_actionButtoncornersRadius',
      },
    },
  },
  productPage_buyNowButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  productPage_buyNowButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_discountNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  productPage_priceColor,
  productPage_strikethroughPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_priceColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_priceColor',
      },
    },
  },
  productPage_salePriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_priceColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_priceColor',
      },
    },
  },
  productPage_background: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_background),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_background',
      },
    },
  },
  productPage_optionsColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsColor',
      },
    },
  },
  productPage_quantityColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsColor',
      },
    },
  },
  productPage_quantityBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_quantityBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  productPage_stockIndicatorColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsColor',
      },
    },
  },
  productPage_preOrderMessageColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_preOrderMessageColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_preOrderMessageColor',
      },
    },
  },
  quickView_preOrderMessageColor,
  productPage_skuColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_skuColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_skuColor',
      },
    },
  },
  productPage_titleTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_titleTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_titleTextColor',
      },
    },
  },
  productPage_paragraphTitleColor,
  quickView_infoSectionTitleTextColor,
  productPage_infoSectionTitleTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_infoSectionTitleTextColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_infoSectionTitleTextColor',
      },
    },
  },
  productPage_galleryBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_galleryBorderColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_galleryBorderColor',
      },
    },
  },
  productPage_mainImageBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => (getStyleParamValue(productPage_layoutId) === LayoutId.Classic ? 1 : 0),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_mainImageCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_subscriptionPlansBoxColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor), // TODO: editor 3 - verify fallback
    },
  },
  productPage_unitPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph3Color), // TODO: editor 3 - verify fallback
    },
  },
  productPage_subscriptionPlanFrequencyColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_subscriptionPlanFrequencyColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_subscriptionPlanFrequencyColor',
      },
    },
  },
  quickView_subscriptionPlanFrequencyColor,
  productPage_headerStripBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_footerStripBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_detailsBoxBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_priceFontStyle,
  productPage_strikethroughPriceFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_priceFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_priceFontStyle',
      },
    },
  },
  productPage_salePriceFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_priceFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'productPage_priceFontStyle',
      },
    },
  },
  productPage_titleFontStyle: {
    type: StyleParamType.Font,
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_titleFontStyle',
      },
    },
  },
  productPage_skuFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_skuFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_skuFontStyle',
      },
    },
  },
  productPage_preOrderMessageFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_preOrderMessageFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_preOrderMessageFontStyle',
      },
    },
  },
  productPage_unitPriceFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  productPage_subscriptionPlanFrequencyFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_subscriptionPlanFrequencyFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_subscriptionPlanFrequencyFontStyle',
      },
    },
  },
  quickView_subscriptionPlanFrequencyFontStyle,
  quickView_textualOptionType,
  productPage_optionsAlignment: {
    type: StyleParamType.Font,
    metadata: null, // deprecated, not relevant for editor 3
  },
  productPage_quantityAlignment: {
    type: StyleParamType.Font,
    metadata: null, // deprecated, not relevant for editor 3
  },
  productPage_priceAlignment: {
    type: StyleParamType.Font,
    metadata: null, // deprecated, not relevant for editor 3
  },
  productPage_socialMediaAlignment: {
    type: StyleParamType.Font,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: Alignment.START,
    }),
    metadata: null, // deprecated, not relevant for editor 3
  },
  productPage_titleAlignment: {
    type: StyleParamType.Font,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: Alignment.START,
    }),
    metadata: null, // deprecated, not relevant for editor 3
  },
  productPage_wishlistIconFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  productPage_wishlistIconBorderSize: {
    type: StyleParamType.Font,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_wishlistButtonCornersRadius: {
    type: StyleParamType.Font,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: '0',
    }),
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_wishlistButtonBorderSize: {
    type: StyleParamType.Font,
    getDefaultValue: () => ({
      fontStyleParam: false,
      value: '1px',
    }),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  productPage_wishlistButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor), // TODO: editor 3 - verify fallback
    },
  },
  productPage_wishlistButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  productPage_wishlistButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  productPage_wishlistButtonTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  quickView_priceColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  quickView_priceFontStyle,
  quickView_background,
  quickView_thumbnailBorder: {
    type: StyleParamType.Color,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  quickView_galleryBorderColor,
  quickView_qtyAndOptionsColor,
  quickView_titleTextColor,
  quickView_titleFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: () => undefined,
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Page-title', // TODO editor 3: verify default value
      },
    },
  },
  quickView_skuColor,
  quickView_skuFontStyle,
  productPage_stickyColumnEnabled: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: false,
      },
    },
  },
  productPage_stickyColumnType: {
    type: StyleParamType.Number,
    getDefaultValue: () => StickyColumnType.INFO,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls which column becomes sticky: product media column (0) or product info column (1)',
      },
      defaultValue: {
        type: 'static',
        value: StickyColumnType.INFO,
      },
    },
  },
  productPage_stickyColumnTop: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 30,
      },
    },
  },
  productPage_galleryImageBorderStyleType: {
    type: StyleParamType.Number,
    getDefaultValue: () => ProductBorderStyleType.OUTLINE,
    metadata: {
      type: StyleType.numberEnum,
      ai: {
        description: 'controls product border style: outline border (1) or inline border (2)',
      },
      defaultValue: {
        type: 'static',
        value: ProductBorderStyleType.OUTLINE,
      },
    },
  },
  productPage_colorSwatchSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
    metadata: {
      type: StyleType.number,
      defaultValue: {
        type: 'static',
        value: 24,
      },
    },
  },
  productPage_colorSwatchCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 12,
      },
    },
  },
  productPage_dropdownListBackgroundOpacityColor: {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_dropdownListTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(quickView_qtyAndOptionsFontStyle),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'quickView_qtyAndOptionsFontStyle',
      },
    },
  },
  productPage_dropdownListTextColor: {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph3Color),
    },
  },
  productPage_dropdownListBorderOpacityColor: {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  productPage_dropdownListBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  productPage_dropdownListCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_dropdownListWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.width,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },

  productPage_textualOptionType,
  productPage_buttonOptionsHorizontalPadding,
  productPage_buttonOptionsVerticalPadding,

  productPage_buttonOptionBorderRadius,
  productPage_buttonOptionTextColor,
  productPage_buttonOptionFontStyle,
  productPage_buttonOptionBorderWidth,
  productPage_buttonOptionBackgroundColor,
  productPage_buttonOptionsGap,
  productPage_buttonOptionBorderColor,
  productPage_buttonOptionHoverBackgroundColor,
  productPage_buttonOptionHoverBorderColor,
  productPage_buttonOptionHoverFontStyle,
  productPage_buttonOptionHoverTextColor,
  productPage_buttonOptionDisabledBackgroundColor,
  productPage_buttonOptionDisabledBorderColor,
  productPage_buttonOptionDisabledTextColor,
  productPage_buttonOptionDisabledFontStyle,
  productPage_buttonOptionSelectedBackgroundColor,
  productPage_buttonOptionSelectedBorderColor,
  productPage_buttonOptionSelectedTextColor,
  productPage_buttonOptionSelectedFontStyle,
  productPage_buttonOptionWidth,
  productPage_buttonOptionsColumnsNumber,
  productPage_buttonOptionsColumnSpacing,
  productPage_buttonOptionTextAlignment,
  productPage_quantityBackgroundOpacity,
  productPage_quantityBorderOpacity,
  productPage_quantityBorderWidth,
  productPage_quantityBoxWidth,
  productPage_quantityBoxCornerRadius,
  productPage_subscriptionsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
      },
    },
  },
  productPage_subscriptionsTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },

  productPage_subscriptionRegularBoxBackgroundColor,
  productPage_subscriptionRegularBorderColor,
  productPage_subscriptionRegularBorderWidth,
  productPage_subscriptionRegularBorderCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  productPage_subscriptionRegularContainerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.width,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  productPage_subscriptionRegularNameFont,
  productPage_subscriptionRegularNameColor,
  productPage_subscriptionRegularTaglineFont,
  productPage_subscriptionRegularTaglineColor,
  productPage_subscriptionRegularPriceFont,
  productPage_subscriptionRegularPriceColor,
  productPage_subscriptionRegularFrequencyFont,
  productPage_subscriptionRegularFrequencyColor,

  productPage_subscriptionSelectedBoxBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularBoxBackgroundColor),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  productPage_subscriptionSelectedBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  productPage_subscriptionSelectedBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularBorderWidth),
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  productPage_subscriptionSelectedNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularNameFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  productPage_subscriptionSelectedNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  productPage_subscriptionSelectedTaglineFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularTaglineFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 12,
      },
    },
  },
  productPage_subscriptionSelectedTaglineColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularTaglineColor),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  productPage_subscriptionSelectedPriceFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularPriceFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  productPage_subscriptionSelectedPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularPriceColor),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  productPage_subscriptionSelectedFrequencyFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularFrequencyFont),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 12,
      },
    },
  },
  productPage_subscriptionSelectedFrequencyColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(productPage_subscriptionRegularFrequencyColor),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
};

export default createStylesParams<StylesParamKeys>(stylesParams);
